/* Copyright (c) 2019 - 2022. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

export const fi = {};
